import { ArrowOutward, Facebook, Instagram } from "@mui/icons-material";
import { Link, NavLink, useLocation } from "react-router-dom";
import Logo from "../../shared/assets/images/Logo.png";
import "./Footer.css";

const Footer = () => {
  const isHome = useLocation().pathname === "/";

  return (
  <footer className="clinic-footer">
    <div className="container clinic-footer__inner">
      {!isHome && <div className="clinic-footer__booking-row">
        <div>
          <p className="clinic-footer__eyebrow">VALSTA TANDLÄKARKLINIK</p>
          <h2>Dags för ditt nästa besök?</h2>
          <p>Boka en tid online eller ring oss så hjälper vi dig.</p>
        </div>
        <a className="clinic-footer__booking" href="https://www.muntra.com/valsta-tandlakarklinik/c/4519?language=sv"
          target="_blank" rel="noopener noreferrer" aria-label="Boka tid hos Muntra (öppnas i en ny flik)">
          Boka tid online <ArrowOutward aria-hidden="true" />
        </a>
      </div>}

      <div className="clinic-footer__grid">
        <div className="clinic-footer__brand">
          <Link to="/" className="clinic-footer__logo" aria-label="Valsta Tandläkarklinik – startsida">
            <img src={Logo} alt="Valsta Tandläkarklinik" width="1035" height="282" loading="lazy" />
          </Link>
          <p>Din tandläkarklinik i Valsta, Märsta.<br />Välkommen att kontakta oss.</p>
          <div className="clinic-footer__socials">
            <a href="https://www.instagram.com/valstatandlakarklink?igsh=MW40Z3FwYmwxOHh0cA=="
              target="_blank" rel="noopener noreferrer" aria-label="Valsta Tandläkarklinik på Instagram (öppnas i en ny flik)">
              <Instagram aria-hidden="true" />
            </a>
            <a href="https://www.facebook.com/share/1CST51d1i5/"
              target="_blank" rel="noopener noreferrer" aria-label="Valsta Tandläkarklinik på Facebook (öppnas i en ny flik)">
              <Facebook aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="clinic-footer__contact">
          <h3>Hitta till oss</h3>
          <address>Valstavägen 32E<br />195 50 Märsta</address>
          <a href="tel:+46859440060">08-594 400 60</a>
          <a href="mailto:info@valsta-tandlakarklinik.se">info@valsta-tandlakarklinik.se</a>
        </div>

        <div className="clinic-footer__hours">
          <h3>Öppettider</h3>
          <dl>
            <div><dt>Måndag–torsdag</dt><dd>08–17</dd></div>
            <div><dt>Fredag</dt><dd>08–14</dd></div>
          </dl>
        </div>

        <nav className="clinic-footer__nav" aria-label="Sidfotsmeny">
          <h3>Utforska</h3>
          <NavLink to="/behandlingar">Behandlingar</NavLink>
          <NavLink to="/om-oss">Om oss</NavLink>
          <NavLink to="/kontakt">Kontakt</NavLink>
          <NavLink to="/blogg">Blogg</NavLink>
        </nav>
      </div>

      <div className="clinic-footer__bottom">
        <p>© {new Date().getFullYear()} Valsta Tandläkarklinik</p>
        <Link to="/privacy-policy">Integritetspolicy</Link>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
